import { defineMessages } from 'react-intl'

export default defineMessages({
  followUp: {
    id: 'patientDossier.visit.followUp',
    defaultMessage: 'Follow Up'
  },
  visit: {
    id: 'patientDossier.visit.visit',
    defaultMessage: 'Visit'
  }
})
